// @flow

import { connect } from "react-redux";

import Feed from "src/components/chatroom/creator/feed";
import { getCurrentUserId } from "src/reducers";

import type { AppState } from "src/types";

const mapStateToProp = ({ app }: { app: AppState }) => ({
  title: app.conversationDialog.title,
  parent: app.conversationDialog.parent,
  currentUser: getCurrentUserId(app),
  owner: app.conversationDialog.owner,
  members: app.conversationDialog.members
});

export default connect(mapStateToProp)(Feed);
